"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrderToJSON = exports.SortOrderFromJSONTyped = exports.SortOrderFromJSON = exports.SortOrder = void 0;
/**
 * Sort order, used for sorting, indicates the direction of sorting
 * @export
 */
exports.SortOrder = {
    Asc: 'ASC',
    Desc: 'DESC'
};
function SortOrderFromJSON(json) {
    return SortOrderFromJSONTyped(json, false);
}
exports.SortOrderFromJSON = SortOrderFromJSON;
function SortOrderFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SortOrderFromJSONTyped = SortOrderFromJSONTyped;
function SortOrderToJSON(value) {
    return value;
}
exports.SortOrderToJSON = SortOrderToJSON;
